import React, { useState } from "react";
import style from "../CommonStyles/commonformstyles.module.scss";
import { MdNavigateNext } from "react-icons/md";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

const steps = [
  "Service Details",
  "Set Pricing",
  "Service Assets",
  // "Description & FAQ",
];

const PreviewPage = ({ formData, setCurrentStep, handleSubmit, isPending }) => {
  const [isPublished, setIsPublished] = useState(false);
  const navigate= useNavigate();

  const handlePublish = async () => {
    try {
      await handleSubmit();
      setIsPublished(true);
      toast.success("Service published successfully!", {
        position: "top-center",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      navigate("/dashboard/services");
    } catch (error) {
      toast.error("Failed to publish service. Please try again.", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    finally{
       navigate("/dashboard/services");
    }
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      
      <h2 className={style.dashboardFormContinerHeading}>Preview Service</h2>
      <p className={style.noEquipmentDescription}>
        Review the details of your service before publishing. Click on any step
        to edit.
      </p>

      <div className={style.verticalTimeline}>
        {steps.map((step, index) => (
          <div key={index} className={style.timelineStepWrapper}>
            <div className={style.stepNumber1}>{index + 1}</div>
            {index < steps.length - 1 && (
              <div className={style.verticalLine}></div>
            )}
            <div
              className={`${style.timelineStep} ${
                index === 2 ? style.disabledStep : ""
              }`}
              onClick={() => index !== 2 && setCurrentStep(index + 1)}
              style={{
                cursor: index === 2 ? "not-allowed" : "pointer",
                opacity: index === 2 ? 0.5 : 1,
              }}
            >
              <div className={style.stepDetails}>
                <p className={style.stepLabel}>Step {index + 1}</p>
                <p className={style.stepTitle}>{step}</p>
              </div>
              {index !== 2 && <MdNavigateNext className={style.nextIcon} />}
            </div>
          </div>
        ))}
      </div>

      <div className={style.formButtonsContainer}>
        <button
          className={`${style.dashboardFormSaveButtonDown} ${
            isPending ? style.disabledButton : ""
          }`}
          type="button"
          onClick={handlePublish}
          disabled={isPending || isPublished}
        >
          {isPending 
            ? "Publishing..." 
            : isPublished 
              ? "Published Successfully" 
              : "Publish Service"}
        </button>
        <button className={style.serviceFormDraftButton} type="button">
          Save as Draft
        </button>
      </div>
    </>
  );
};

export default PreviewPage;